
















import { getEmail } from '@/utils/cookie';
import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';

@Component({
  metaInfo(this: Review): MetaInfo {
    return {
      title: 'Review Us |',
      meta: [
        ...seoDefault({
          title: 'Review Us | Mysoalan',
          description:
            'Help us grow our services by reviewing Mysoalan. Your feedback would help us a lot to improve Mysoalan to be a better solution for your tools in creating exams or practice papers.',
        }),
      ],
    };
  },
})
export default class Review extends Vue {
  get userEmail() {
    return getEmail();
  }

  formSrc =
    'https://docs.google.com/forms/d/e/1FAIpQLSe5QiReWiNZWb7kVBju2hTNrs6fx8pQECmotwLkpMvn9prBXw/viewform?usp=pp_url&entry.811517353=';

  created() {
    if (this.userEmail) {
      this.formSrc = this.formSrc + this.userEmail;
    }
  }
}
